import React from 'react';
import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { GroupOverviewItem } from '../model';

interface GroupOverviewProps {
  items: GroupOverviewItem[];
}

const GroupOverview: React.FC<GroupOverviewProps> = ({ items }) => {
  if (items.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        No groups for this location.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {items.map((item) => (
        <Card key={item.groupId} variant="outlined">
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1 }}>
              <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600 }}>
                {item.groupId} · {item.totalUsers} users
              </Typography>
              <Chip label={item.departments.length} size="small" color="primary" variant="outlined" />
            </Box>
            <Box>
              {item.departments.map((department) => (
                <Box
                  key={department.id}
                  display="flex"
                  justifyContent="space-between"
                  sx={{ fontSize: '0.875rem', py: 0.25 }}
                >
                  <span>{department.name}</span>
                  <Box component="span" sx={{ color: 'text.secondary' }}>
                    {department.userCount}
                  </Box>
                </Box>
              ))}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default GroupOverview;
